import React, {Component} from 'react';
import { connect } from 'dva';
import { Button } from 'antd';
import BaseComponent from '../../../components/BaseComponent';

class SortPrice extends BaseComponent {
  constructor(props) {
    super(props);
    this.handleSort = this.handleSort.bind(this);
  }

  handleSort(e){
    const {dispatch} = this.props;

    dispatch({
      type: 'search/sortPrice'
    });
  }

  render() {
    const {search:{sortPrice}} = this.props;

    return(
      <div>
        <Button className="" onClick={this.handleSort}>値段 &nbsp;
          {sortPrice && sortPrice == 'asc' ?
            <i className="fa fa-arrow-up"></i>
            :
            <i className="fa fa-arrow-down"></i>
          }
        </Button>
      </div>
    )
  }
}

export default connect(({ search }) => ({
  search
}))(SortPrice);



// WEBPACK FOOTER //
// ./src/pages/search/components/SortPrice.js